import Link from 'gatsby-link'
import React from 'react'
import SoftinLogo from '../../assets/img/logos/softin.svg'

function Footer() {
  return (
    <footer className="footer py-5 px-4">
      <div className="d-md-flex justify-between">
        <p className="mr-auto font-inter">
          © 2021 Gravíttem. Todos os direitos reservados.
        </p>
        <span className="d-inline-flex">
          <p className="mr-2 text-md-right mt-10 ml-md-auto font-inter">
            Desenvolvido por{' '}
          </p>
          <Link to="/" className="w-25 h-50">
            <img alt="" src={SoftinLogo} className="w-75 h-100 mt-1" />
          </Link>
        </span>
      </div>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/newLayout/Footer.js